import React, { useState } from "react";

import { Alert, Button, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import DwellLogo from "../../../common/components/DwellLogo";
import { forgotPassword } from "../services";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<null | string>(null);
  const [validated, setValidated] = useState(false);

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    mutationForgotPassword.mutate();
  };

  const mutationForgotPassword = useMutation({
    mutationFn: () => forgotPassword(email),
    onError: (error) => {
      console.error(error);
      toast.error("Erreur lors de la sauvegarde de l'utilisateur");
    },
    onSuccess: async () => {
      setMessage(
        "Si votre adresse e-mail est associée à un compte, vous recevrez un e-mail avec des instructions pour réinitialiser votre mot de passe.",
      );
    },
  });

  return (
    <div>
      <Container className="d-flex flex-column min-vh-100 justify-content-center align-items-center flex-wrap register-form">
        <Row className="align-items-center justify-content-center">
          <h3 className="text-center mb-0 fw-bold register-title mb-4">
            Mot de passe oublié
          </h3>
          <h5 className="text-center mt-0 fw-bold register-subtitle2 mb-5">
            Pas de panique, nous allons vous envoyer des instructions pour
            réinitialiser votre mot de passe.
          </h5>
          <Form
            className=""
            validated={validated}
            onChange={(e) => setValidated(e.currentTarget.checkValidity())}
            onSubmit={handleSubmit}
          >
            <Form.Group className="mb-3" controlId="email">
              <Form.Control
                type="email"
                placeholder="E-mail professionnel"
                autoComplete="email"
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
            {!mutationForgotPassword.isSuccess ? (
              <div className="text-center">
                <Button
                  className="mt-4 mb-0 w-100"
                  variant="success"
                  type="submit"
                  disabled={mutationForgotPassword.isLoading}
                >
                  Réinitialiser le mot de passe
                </Button>
              </div>
            ) : null}

            <Form.Group
              className="mt-3 mb-3 text text-center"
              controlId="password"
            >
              <Form.Text id="passwordHelpBlock">
                <Link to="/login" className="password-help-link">
                  Retour à la connexion
                </Link>
              </Form.Text>
            </Form.Group>
          </Form>
        </Row>
        <Row>{message && <Alert variant="success">{message}</Alert>}</Row>
      </Container>
      <div className="position-absolute top-0 start-0 p-3">
        <DwellLogo linkTo="/login" />
      </div>
    </div>
  );
}
